<template>
  <div>
    <CRow>
      <CCol col="12" md="8">
        <CCard>
          <CCardHeader>
            <div class="d-flex align-items-center header-actions">
              <strong>{{ $t('panel_users') }}</strong>
              <CButton
                  color="primary"
                  size="sm"
                  @click="openAddUserModal"
                  class="d-md-none add-user-btn"
              >{{ $t('add_new_user') }}</CButton>
            </div>
          </CCardHeader>
          <CCardBody>

            <CDataTableFixed
                :items="items"
                :fields="fields"

                :items-per-page="20"
                hover
                sorter
                pagination
            >
              <template #row="{item,index}">
                <td>
                  <p class="text-muted">{{ index + 1 }}</p>
                </td>
              </template>
              <template #name="{item}">
                <td>
                  <p class="text-muted">{{ item.name }}</p>
                </td>
              </template>
              <template #role_group="{item}">

                <td>
                  <p class="text-muted">{{ item.role_group.role_group.name }}</p>

                </td>

              </template>


              <template #phone="{item}">

                <td>
                  <p class="text-muted">{{ item.phone }}</p>

                </td>

              </template>



              <template #image="{item}">


                <td>
                  <CImg width="50px" height="50px" v-bind:src="item.image"/>
                </td>

              </template>

              <template #operation="{item,index}">
                <td class="py-2">
                  <CButton
                      color="warning"
                      variant="outline"
                      square
                      size="sm"
                      class="mr-1"
                      @click="editDetails(item)"
                  >
                    <CIcon name="cil-pencil" size="sm"/>
                  </CButton>
                  <CButton
                      color="danger"
                      variant="outline"
                      square
                      class="mr-1"

                      size="sm"
                      @click="delete_user(item,index)"
                  >
                    <CIcon name="cil-trash" size="sm"/>
                  </CButton>
                </td>
              </template>


            </CDataTableFixed>
          </CCardBody>
        </CCard>

      </CCol>
      <CCol col="12" md="4" class="d-none d-md-block">
        <CCard>
          <CCardHeader>
            <strong>{{ $t('add_user') }}</strong>

          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="12">
                <CInput
                    v-model="name"

                    :label="$t('full_name')"

                />
              </CCol>
            </CRow>
            <CRow>
              <CCol col="12">
                <CInput v-if="$i18n.locale=='fa'"
                    v-model="mobile"
                    :label="$t('mobile_no')"
                    :placeholder="$t('mobile_no')"
                />
                <CInput v-else
                    v-model="email"
                    :label="$t('email')"
                    :placeholder="$t('email')"
                />

              </CCol>
            </CRow>

            <CRow>
              <CCol col="12">
                <CInput
                    v-model="password"

                    :label="$t('password')"
                    :placeholder="$t('password')"

                />

              </CCol>
              <CCol col="12">
                <ImageSelector :label="$t('image')"
                               :media_id.sync="file"
                               default_archive="site"
                               :preview-image="previewImage"
                />

              </CCol>
            </CRow>


          </CCardBody>
          <CCardFooter>
            <CButton v-if="status_form==0"
                     @click="insert_data()"
                     size="sm" color="primary">{{ $t('add_user') }}</CButton>
            <CButton v-if="status_form!=0"
                     @click="insert_data()"
                     class="mr-1"
                     size="sm" color="warning">{{ $t('edit_user') }}</CButton>
            <CButton v-if="status_form!=0"
                     @click="cancel_form()"
                     class="mr-1"

                     size="sm" color="danger">{{ $t('cancel') }}</CButton>
          </CCardFooter>
        </CCard>
      </CCol>

    </CRow>

    <!-- Modal for Add/Edit User -->
    <CModal
        :title="status_form == 0 ? $t('add_new_user')  :  $t('edit_user') "
        :show.sync="showUserModal"
        color="primary"
        size="lg"
        :centered="true"
        class="user-modal"
    >
      <CCardBody>
        <CRow>
          <CCol col="12">
            <CInput
                v-model="name"
                :label="$t('full_name')"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol col="12">
            <CInput v-if="$i18n.locale=='fa'"
                v-model="mobile"
                :label="$t('mobile_no')"
                :placeholder="$t('mobile_no')"
            />
            <CInput v-else
                v-model="email"
                :label="$t('email')"
                :placeholder="$t('email')"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol col="12">
            <CInput
                v-model="password"
                :label="$t('password')"
                :placeholder="$t('password')"
            />
          </CCol>
          <CCol col="12">
            <ImageSelector :label="$t('image')"
                           :media_id.sync="file"
                           default_archive="site"
                           :preview-image="previewImage"
            />
          </CCol>
        </CRow>
      </CCardBody>
      <template #footer>
        <CButton v-if="status_form==0"
                 @click="insert_data()"
                 size="sm" color="primary">{{ $t('add_user') }}</CButton>
        <CButton v-if="status_form!=0"
                 @click="insert_data()"
                 class="mr-1"
                 size="sm" color="warning">{{ $t('edit_user') }}</CButton>
        <CButton
            @click="closeUserModal()"
            class="mr-1"
            size="sm" color="secondary">{{ $t('cancel') }}</CButton>
      </template>
    </CModal>

  </div>

</template>

<script>
import axios from "axios";
import {bus} from '../../main';

var items = [];


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name: new Date().getTime() + "_" + this.$vnode.tag,

      name: '',
      email: '',
      mobile: '',
      password: '',
      selected_group: 0,
      file: [],
      previewImage: null,
      description: '',
      items: [],
      role_groups: [],
      fields: [
        {key: 'row', label: '#', _style: 'width:10%'},
        {label: this.$t('full_name'),key: 'name', _style: 'width:10%'},
        // {key: 'ایمیل', _style: 'width:10%'},
        {label: this.$t('mobile_no'),key: 'phone', _style: 'width:10%;'},
        // {key: 'role_group', label: 'گروه دسترسی', _style: 'width:10%;'},
        {label: this.$t('operation'),key: 'operation', _style: 'width:10%;'},

      ],
      details: [],
      collapseDuration: 0,
      status_form: 0,
      showUserModal: false
    }
  },
  components: {},
  mounted() {
if(this.$i18n.locale!='fa'){
  this.fields= [
    {key: 'row', label: '#', _style: 'width:10%'},
    {label: this.$t('full_name'),key: 'name', _style: 'width:10%'},
    {key: this.$t('email'), _style: 'width:10%'},
    {label: this.$t('operation'),key: 'operation', _style: 'width:10%;'},

  ]
}
    bus.$on(this.confirm_delete_name, (data) => {
      if (data == 'true') {
        this.delete_admin();

      } else {
        this.status_form = 0;
      }
    });
    this.get_groups();
    this.get_admins();

  }, watch: {
    '$route.params.cat_id': function (id) {
      this.get_categories();
    },

  },
  methods: {
    openAddUserModal() {
      this.cancel_form();
      this.showUserModal = true;
    },
    closeUserModal() {
      this.showUserModal = false;
      this.cancel_form();
    },
    editDetails(item) {
      this.name = item.name
      this.email = item.email
      this.mobile = item.phone
      this.password = item.password
      this.selected_group = item.role_group ? item.role_group.group_id : 0
      this.file[0] = item.image_id
      this.status_form = item.id
      this.previewImage = item.image || null
      this.showUserModal = true;
    },
    cancel_form() {
      this.name = ''
      this.email = ''
      this.mobile = ''
      this.password = ''
      this.selected_group = 0
      this.status_form = 0
      this.previewImage = null
      this.file = []
    },
    insert_data() {


      let self = this;
      const formData = new FormData()
      let url;
      if (this.status_form == 0) {
        url = "/api/admin/user/insert_admin";
      } else {
        url = "/api/admin/user/update_admin";
        formData.append('id', this.status_form)
      }

      formData.append('image', this.file[0]);
      formData.append('name', this.name);
      formData.append('mobile', this.mobile);
      formData.append('email', this.email);
      formData.append('password', this.password);
      formData.append('role_group', this.selected_group);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        if (res.data.error == 0) {
          self.cancel_form();
          self.showUserModal = false;
          self.get_admins()
        }
      }).catch(function (error) {

        console.log(error);
      });

    },

    get_groups() {
      var self = this;

      var formData = new FormData();

      axios.post('/api/admin/user/get_permission_group', formData, {}).then(function (response) {

        var content_cats = response.data.groups;
        self.role_groups = self.sort_array([{label: 'انتخاب کنید', value: 0}], content_cats, 'id', 'name')

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_admins() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);
      var formData = new FormData();
      axios.post('/api/admin/user/get_admin', formData, {}).then(function (response) {

        var content_cats = response.data;

        self.items = content_cats.map((item, row_id) => {
          return {...item, row_id}
        });

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_user(item) {
      this.$root.modal_component.show_confirm_modal('اخطار', "آیا مایل به حذف این کاربر هستید؟", ['تایید'], this.confirm_delete_name);

      this.status_form = item.id;

    },

    delete_admin() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/user/delete_admin";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.status_form = 0;

        self.get_admins();


      })
          .catch(function (error) {

            console.log(error);
          });
    },
  }
}


</script>

<style scoped>
.header-actions {
  width: 100%;
  flex-direction: row-reverse;
  justify-content: space-between;
}

.header-actions strong {
  order: 2;
}

.add-user-btn {
  order: 1;
}

.user-modal :deep(.modal-dialog) {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
  margin: 0.5rem auto;
}

.user-modal :deep(.modal-content) {
  margin: auto;
}

@media (max-width: 991px) {
  .user-modal :deep(.modal-dialog) {
    min-height: calc(100% - 3.5rem);
    margin: 1.75rem auto;
  }
}
</style>
